import { gql } from '@apollo/client';

export default gql`
  mutation addMissedDepartureSegments($bookingReference: String!, $exchangeItems: [Int]!, $trainNumber: String!) {
    addMissedDepartureSegments(bookingReference: $bookingReference, exchangeItems: $exchangeItems, trainNumber: $trainNumber) {
      reference
    }
  }
`;
